import moment from 'moment';
import {useEffect, useState} from 'react'

export default function useTimerShow() {
    const [DateMoment, setDateMoment] = useState(
      {
        days:moment().format('DD'),
        months:moment().format('MM'),
        years:moment().format('YYYY'),
        hours:moment().format('H'),
        minutes:moment().format('mm'),
        seconds:moment().format('s')
      }
    );
    const getTime = () => {
      setDateMoment({
        days:moment().format('DD'),
        months:moment().format('MM'),
        years:moment().format('YYYY'),
        hours:moment().format('H'),
        minutes:moment().format('mm'),
        seconds:moment().format('s')
      });
    };

    useEffect(() => {
      const interval = setInterval(() => getTime(), 1000);

      return () => clearInterval(interval);
    }, []);

    return DateMoment;
}
